import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import { useIntl } from "react-intl";
import { Form, Icon, Popup } from "semantic-ui-react";
import { Config } from "../../../../config/api";
import "react-datepicker/dist/react-datepicker.css";

export const DateRangePickerField = ({
  values,
  onStartDateChange,
  onEndDateChange,
  minimalStartDate,
  maximalEndDate,
  tooltipMessage,
}) => {
  const intl = useIntl();

  return (
    <Form.Group>
      <Form.Field className="filter-field">
        <label>
          {intl.formatMessage({
            id: "LABEL_DATE_RANGE",
            defaultMessage: "Date Range",
          })}
          {tooltipMessage && (
            <Popup
              inverted
              style={{ marginLeft: "0.5em" }}
              content={
                <div>
                  {tooltipMessage.split("\n").map((line) => (
                    <div key={line}>{line}</div>
                  ))}
                </div>
              }
              size="mini"
              trigger={
                <Icon
                  name="help circle"
                  style={{ position: "relative" }}
                  className="cursor-help"
                />
              }
            />
          )}
        </label>
        <Form.Field className="date-picker">
          <DatePicker
            selected={values.start_date}
            minDate={minimalStartDate}
            maxDate={values.end_date}
            onChange={onStartDateChange}
            dateFormat={Config.dateTimeFormat}
          />
        </Form.Field>
      </Form.Field>
      <Form.Field className="filter-field">
        <label>&nbsp;</label>
        <Form.Field className="date-picker">
          <DatePicker
            selected={values.end_date}
            minDate={values.start_date}
            maxDate={maximalEndDate}
            onChange={onEndDateChange}
            dateFormat={Config.dateTimeFormat}
          />
        </Form.Field>
      </Form.Field>
    </Form.Group>
  );
};

DateRangePickerField.propTypes = {
  values: PropTypes.object.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  minimalStartDate: PropTypes.instanceOf(Date),
  maximalEndDate: PropTypes.instanceOf(Date),
  tooltipMessage: PropTypes.string,
};
